   import { plat, orgCustoms} from '../dataJson/custom.js'

   export default {
        quanjutiaozhuan(value, item) {
            let IP = orgCustoms[plat].IP,
                URL = '?loadType=1&ebookId=' + item + '&authKey=' + localStorage.authKey;
            // 1：epub格式；0：pdf格式
            if(value == '0'){
                URL = '/pdfindex.html' + URL;
            }
            window.open(IP + URL, '_blank');
        }
    }


//    function quanjutiaozhuan(value,item){
//         // let url = "http://yt.gxjsxy.cn:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //广西建设职业技术学院
//         // let url = "http://172.16.3.63:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //广西建设职业技术学院
//         // let url = "http://10.10.230.224:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //青岛农业大学海都学院
//         // let url = "http://192.168.7.186:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //詹彦涛
//         // let url = "http://192.168.7.166:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //宋轶琨电脑
//         // let url = "http://10.8.3.19:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //锦州医科大学
//         // let url = "http://192.168.10.97:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey;//97环境
//         // let url = "http://192.168.10.96:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //线上96
//         let url = "http://viewery.ytzhihui.com/index.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey;//book05
//         // let url = "http://219.216.224.121:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey;//辽宁经贸
//         // let url = "http://192.168.73.35:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey;//江苏卫生健康职业学院
//         // let url = "http://192.168.10.77:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey
//         // let url = "http://10.9.18.205:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey
//         // let url = "http://172.16.58.158:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //贺州职业技术学院服务器
//         //let url = "http://ebookrd.lnut.edu.cn/index.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey
//         // let url = "http://10.10.32.7:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //南京铁道职业技术学院
//         // let url = "http://192.168.20.188:89?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //福建幼儿师范
        
//         // 1：epub格式；0：pdf格式
//         if(value == '0'){
//             // url = "http://172.16.3.63:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //广西建设职业技术学院
//             // url = "http://yt.gxjsxy.cn:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //广西建设职业技术学院
//             // url = "http://10.10.230.224:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //青岛农业大学海都学院
//             // url = "http://192.168.7.166:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //宋轶琨电脑
//             // url = "http://192.168.7.186:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //詹彦涛
//             // url = "http://10.8.3.19:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey;//锦州医科大学
//             // url = "http://192.168.10.97:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey;//97环境
//             // url = "http://192.168.10.96:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //线上96
//             url = "http://viewery.ytzhihui.com/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey;//book05
//             // url = "http://219.216.224.121:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //辽宁经贸
//             // url = "http://192.168.73.35:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //江苏卫生健康职业学院
//             // url = " http://192.168.10.77:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey
//             // url = "http://10.9.18.205:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey
//             // url = "http://172.16.58.158:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //贺州职业技术学院服务器
//             //url = "http://218.193.33.19:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey
//             //url = "http://ebookrd.lnut.edu.cn/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey
//             // url = "http://10.10.32.7:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //南京铁道职业技术学院
//             // url = "http://192.168.20.188:89/pdfindex.html?loadType=1&ebookId=" + item + "&authKey=" + localStorage.authKey; //福建幼儿师范
//         }
//         // let hostName = window.location.href;
//         // if(hostName.indexOf('tsg2.gxhzvc.cn') > -1){
//         //     url = url.replace(/172.16.58.158:89/, 'tsg4.gxhzvc.cn'); //贺州职业技术学院阅读跳转域名替换
//         // }
//         window.open(url);      
//     }
//     export default {
//         quanjutiaozhuan
//     }





// WEBPACK FOOTER //
// ./src/components/tiaozhuan.js